import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Profile } from "@/hooks/profile/types";

export const useGymQueries = (profile: Profile) => {
  // Query para obtener los gimnasios asociados al usuario
  const { data: userGyms } = useQuery({
    queryKey: ["userGyms", profile.id],
    queryFn: async () => {
      if (!profile.id) return [];
      
      // Para managers y profesores: obtener gimnasios gestionados
      if (profile.role === "profesor" || profile.role === "manager") {
        const { data } = await supabase
          .from("gym_managers")
          .select("gyms(*)")
          .eq("manager_id", profile.id);
        return data?.map(record => record.gyms) || [];
      }
      
      // Para todos los usuarios: obtener membresías de gimnasios
      const { data } = await supabase
        .from("user_gym_memberships")
        .select("gyms(*)")
        .eq("user_id", profile.id)
        .eq("is_active", true);
      return data?.map(record => record.gyms) || [];
    },
    enabled: !!profile.id,
  });

  // Query para obtener detalles del gimnasio actual
  const { data: currentGym } = useQuery({
    queryKey: ["gym", profile.gym_id],
    queryFn: async () => {
      if (!profile.gym_id) return null;
      const { data } = await supabase
        .from("gyms")
        .select("name, logo_url")
        .eq("id", profile.gym_id)
        .single();
      return data;
    },
    enabled: !!profile.gym_id,
  });

  return {
    userGyms,
    currentGym
  };
};